'use client';

import { useEffect } from 'react';
import Link from 'next/link';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('[Global] unhandled error:', error);
  }, [error]);

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '80px 32px',
        background: 'var(--seasons-color-surface-subtle, #f9fafb)',
        fontFamily: 'var(--seasons-font-polysans, system-ui, sans-serif)',
      }}
    >
      <p style={{ fontSize: 36, margin: '0 0 16px' }}>⚠️</p>
      <h1
        style={{
          fontSize: '1.25rem',
          fontWeight: 600,
          color: 'var(--seasons-color-prose-heading, #0a0e1a)',
          margin: '0 0 8px',
        }}
      >
        Something went wrong
      </h1>
      <p
        style={{
          fontSize: '0.9375rem',
          color: 'var(--seasons-color-text-secondary, #6b7280)',
          margin: '0 0 32px',
          maxWidth: 480,
        }}
      >
        An unexpected error occurred. Try refreshing the page, or return home.
      </p>
      <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', justifyContent: 'center' }}>
        <button
          onClick={reset}
          style={{
            padding: '10px 20px',
            border: '1px solid var(--seasons-color-border-default, #e5e7eb)',
            borderRadius: 6,
            background: 'var(--seasons-color-surface-default, #fff)',
            color: 'var(--seasons-color-text-default, #111827)',
            fontSize: '0.875rem',
            fontWeight: 500,
            cursor: 'pointer',
          }}
        >
          Try again
        </button>
        <Link
          href="/"
          style={{
            padding: '10px 20px',
            border: 'none',
            borderRadius: 6,
            background: 'var(--seasons-color-midnight, #0a0e1a)',
            color: '#fff',
            fontSize: '0.875rem',
            fontWeight: 500,
            textDecoration: 'none',
            display: 'inline-flex',
            alignItems: 'center',
          }}
        >
          Go home
        </Link>
      </div>
    </div>
  );
}
